import { createAction } from 'redux-actions';
import * as actions from './actions';

export const fetchReviewsRequest = createAction(actions.FETCH_REVIEWS_REQUEST);
export const fetchReviewsSuccess = createAction(actions.FETCH_REVIEWS_SUCCESS);
export const fetchReviewsFailure = createAction(actions.FETCH_REVIEWS_FAILURE);

export const fetchPublicCottageRequest = createAction(actions.FETCH_PUBLIC_COTTAGE_REQUEST);
export const fetchPublicCottageSuccess = createAction(actions.FETCH_PUBLIC_COTTAGE_SUCCESS);
export const fetchPublicCottageFailure = createAction(actions.FETCH_PUBLIC_COTTAGE_FAILURE);

export const postReviewRequest = createAction(actions.POST_REVIEW_REQUEST);
export const postReviewSuccess = createAction(actions.POST_REVIEW_SUCCESS);
export const postReviewFailure = createAction(actions.POST_REVIEW_FAILURE);

export const postReviewReplyRequest = createAction(actions.POST_REVIEW_REPLY_REQUEST);
export const postReviewReplySuccess = createAction(actions.POST_REVIEW_REPLY_SUCCESS);
export const postReviewReplyFailure = createAction(actions.POST_REVIEW_REPLY_FAILURE);

export const setReplyFormId = createAction(actions.REVIEWS_SET_REPLY_FORM_ID);
export const resetList = createAction(actions.REVIEWS_RESET_LIST);

export const deleteReviewRequest = createAction(actions.DELETE_REVIEW_REQUEST);
export const deleteReviewFailure = createAction(actions.DELETE_REVIEW_FAILURE);
export const deleteReviewSuccess = createAction(actions.DELETE_REVIEW_SUCCESS);

export const deleteReviewReplyRequest = createAction(actions.DELETE_REVIEW_REPLY_REQUEST);
export const deleteReviewReplyFailure = createAction(actions.DELETE_REVIEW_REPLY_FAILURE);
export const deleteReviewReplySuccess = createAction(actions.DELETE_REVIEW_REPLY_SUCCESS);
